module.exports = __webpack_public_path__ + "cw.svg?5e1e838d56f64ef7953dba5b1aafac57";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/cw.svg
// module id = 1035
// module chunks = 27